import ViewTrackingService from 'services/ViewTrackingService';
import HttpService from 'services/HttpService';
import { getMVPDName } from 'helpers/mvpdStorage';
import { TVProvider } from 'POJOs/TVProvider';

const ENDPOINT = {
    PROVIDER_ENDPOINT: '/live-tv/stream/tveverywhere/mvpd-configs/'
};

// Legacy provider tracker
// TODO: Remove during cleanup - PPLUSINTL-5906
export default class LiveTVTrackingService extends ViewTrackingService {
    constructor() {
        super();
        this.defaultParams.siteSection = 'cbs svod';
        this.http = new HttpService();
    }

    trackTVProviderSelected(provider) {
        this.trackView({
            pageName: '/live-tv/stream/tveverywhere/provider signin',
            siteHier: 'cbs svod|liveTV|provider|signin',
            pageType: 'svod_provider_signin',
            mvpdPartner: provider.providerName,
            mvpdPartnerId: provider.providerID
        });
        
        this.trackAction('trackTvProvider', {
            mvpdPartner: provider.providerName,
            mvpdPartnerId: provider.providerID
        });
    }

    trackSelectedTVProviderNotAuthorized() {
        this.trackView({
            pageName: '/live-tv/stream/tveverywhere/provider not authorized',
            siteHier: 'cbs svod|liveTV|provider|notauthorized',
            pageType: 'svod_provider_notauthorized'
        });
    }

    trackLiveTVAvailabilityCheck() {
        this.trackView({
            pageName: '/live-tv/check-availability',
            siteHier: 'live-tv',
            pageType: 'live-tv-guide'
        });
    }

    
    trackLiveTVAvailabilityStatus(status) {
        this.__getProvider().then((provider) => {
            if (provider) {
                this.trackView({
                    pageName: '/live-tv/check availability',
                    siteHier: 'live-tv',
                    pageType: status ? 'live-tv' : 'svod_livetv_unavailable',
                    locationCheckResult: status
                        ? 'svod_livetv_available'
                        : 'svod_livetv_unavailable',
                    mvpdPartner: provider.providerName,
                    mvpdPartnerId: provider.providerID,
                    mvpdAuthStreamAvailable: status ? '1' : '0'
                });
            }
        });
    }

    trackMVPDAvailabilityCheck(provider) {
        this.trackView({
            pageName: '/live-tv/stream/tveverywhere/provider availability',
            siteHier: 'cbs svod|liveTV|provider|availability',
            mvpdPartner: provider.providerName,
            mvpdPartnerId: provider.providerID,
            pageType: 'tv-provider',
            mvpdAuthStreamAvailable: '1'
        });
    }

    trackMVPDAvailabilityStatus(status, provider) {
        let pgName, hier, pgType;

        switch (status) {
            case 'unavailable':
                pgName = '/live-tv/stream/tveverywhere/provider unavailable';
                hier = 'cbs svod|liveTV|provider|unavailable';
                pgType = 'svod_provider_unavailable';
                break;
            case 'unknown':
                pgName = '/live-tv/stream/tveverywhere/provider unknown';
                hier = 'cbs svod|liveTV|provider|unknown location';
                pgType = 'svod_provider_unknown';
                break;
            case 'notsupported':
                pgName = '/live-tv/stream/tveverywhere/provider not supported';
                hier = 'cbs svod|liveTV|provider|notsupported';
                pgType = 'svod_provider_notsupported';
                break;
        }

        this.trackView({
            pageName: pgName,
            siteHier: hier,
            mvpdPartner: provider.providerName,
            mvpdPartnerId: provider.providerID,
            pageType: 'tv-provider',
            mvpdAuthStreamAvailable: '0'
        });
    }

    trackTVProviderSelection() {
        this.trackView({
            pageName: '/live-tv/stream/tveverywhere/provider select',
            siteHier: 'cbs svod|liveTV|provider|select',
            pageType: 'tv-provider'
        });
    }

    trackSignInModal() {
        this.trackView({
            pageName: '/live-tv/stream/tveverywhere/cbs signin',
            siteHier: 'cbs svod|liveTV|cbsreg|signin',
            pageType: 'svod_cbsreg_signin',
            userLoginType: 'mvpd'
        });
    }

    trackSignUpModal() {
        this.trackView({
            pageName: '/live-tv/stream/tveverywhere/cbs signup',
            siteHier: 'cbs svod|liveTV|cbsreg|signup',
            pageType: 'svod_cbsreg_signup'
        });
    }

    trackAfterMVPDVerified() {
        this.trackView({
            pageName: '/live-tv/stream/tveverywhere/provider verified cbsreg',
            siteHier: 'cbs svod|liveTV|provider|verified cbsreg',
            pageType: 'svod_provider_verified_cbsreg'
        });
    }

    trackTVProviderSuccess(provider) {
        this.trackView({
            pageName: '/live-tv/stream/tveverywhere/provider verified cbsreg',
            siteHier: 'cbs svod|liveTV|provider|verified cbsreg',
            pageType: 'tv-provider',
            mvpdPartner: provider.providerName,
            mvpdPartnerId: provider.providerID,
            mvpdAuthStreamAvailable: '1'
        });
        this.trackAction('trackTvProviderSuccess', {
            mvpdPartner: provider.providerName,
            mvpdPartnerId: provider.providerID,
            mvpdEventSuccess: '1',
            pageType: 'tv-provider',
            pageViewGuid: window.__page_uuid || ''
        });
    }

    trackMVPDLogout(provider) {
        this.trackAction('trackMvpdLogOut', {
            mvpdPartner: provider.providerName,
            mvpdPartnerId: provider.providerID
        });
    }

    trackStationSelected(channel, station) {
        if (CBS.Registry.brand.name === 'CBS') {
            this.trackAction('trackLiveChannelSelect', {
                liveTvChannel: channel,
                stationCode: station.name,
                TVELockedBadge: CBS.Registry.user.isMVPDAuthZ ? 1 : 0
            });
        }
    }

    trackNoCoverage(channel, title) {
        if (CBS.Registry.brand.name === 'CBS') {
            this.trackState({
                pageType: 'upsell_tve',
                upsellType: 'live-tv|channel|' + channel,
                rowHeaderTitle: title
            });
        }
    }

    trackContentLockCta(title, cta) {
        if (CBS.Registry.brand.name === 'CBS') {
            om.trackAction('trackCta1TVEUpsell', {
                rowHeaderTitle: title,
                ctaText: cta
            });
        }
    }

    /**
     * Get selected provider from MVPD if exists
     * @returns {Promise}
     * @private
     */
    __getProvider() {
        let mvpdName = getMVPDName();
        if (mvpdName.length > 0) {
            return this.http.doGet(ENDPOINT.PROVIDER_ENDPOINT + mvpdName + '/').then((resp) => {
                return new TVProvider({
                    ID: resp.data.result.adobe_id,
                    displayName: resp.data.result.mvpd,
                    logo: resp.data.result.filepath_adobe_logo_white_override,
                    logoBlack: resp.data.result.filepath_adobe_logo_black_override,
                    tier: resp.data.result.tier
                });
            });
        }

        return Promise.resolve(null);
    }
}
